"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    combineName: function() {
        return combineName;
    },
    extractName: function() {
        return extractName;
    },
    getInitials: function() {
        return getInitials;
    }
});
const _object = require("../utils/object");
function extractName(fullName) {
    var _fullName_trim;
    fullName = (_fullName_trim = fullName == null ? void 0 : fullName.trim()) != null ? _fullName_trim : '';
    const [first, ...rest] = fullName.split(' ');
    const last = rest == null ? void 0 : rest.pop();
    var _first_trim, _rest_join_trim, _last_trim;
    const out = (0, _object.deleteUndefined)({
        firstName: (_first_trim = first == null ? void 0 : first.trim()) != null ? _first_trim : '',
        middleName: (_rest_join_trim = rest.join(' ').trim()) != null ? _rest_join_trim : '',
        lastName: (_last_trim = last == null ? void 0 : last.trim()) != null ? _last_trim : ''
    });
    return out;
}
function combineName(input) {
    const { firstName, lastName } = input != null ? input : {};
    var _trim;
    return (_trim = `${firstName != null ? firstName : ''} ${lastName != null ? lastName : ''}`.trim()) != null ? _trim : '';
}
function getInitials(input) {
    let first;
    let last;
    if (typeof input === 'string') {
        var _rest_pop;
        var _input_trim;
        input = (_input_trim = input == null ? void 0 : input.trim()) != null ? _input_trim : '';
        const [firstName, ...rest] = input.split(' ');
        var _firstName_trim;
        first = (_firstName_trim = firstName == null ? void 0 : firstName.trim()) != null ? _firstName_trim : '';
        var _rest_pop_trim;
        last = (_rest_pop_trim = rest == null ? void 0 : (_rest_pop = rest.pop()) == null ? void 0 : _rest_pop.trim()) != null ? _rest_pop_trim : '';
    } else {
        var _input_firstName, _input_lastName;
        var _input_firstName_trim;
        first = (_input_firstName_trim = input == null ? void 0 : (_input_firstName = input.firstName) == null ? void 0 : _input_firstName.trim()) != null ? _input_firstName_trim : '';
        var _input_lastName_trim;
        last = (_input_lastName_trim = input == null ? void 0 : (_input_lastName = input.lastName) == null ? void 0 : _input_lastName.trim()) != null ? _input_lastName_trim : '';
    }
    const initials = [
        first,
        last
    ].filter((n)=>n).map((n)=>n.substring(0, 1)).join('');
    return initials;
}

//# sourceMappingURL=name.js.map